import PostCard from './PostCard'

export { PostCardEventSpecific } from './PostCardEventSpecific'

export default PostCard
